<ng-container *ngIf="state && currentStep">
  <div class="help-overlay-root" role="dialog" aria-modal="true" [attr.aria-label]="state.name">
    <div class="help-overlay-dim" aria-hidden="true"></div>

    <div class="help-overlay-ring" [ngStyle]="ringStyle" aria-hidden="true"></div>

    <div class="help-overlay-pin" [ngStyle]="pinStyle" aria-hidden="true">
      {{ state.index + 1 }}
    </div>

    <div class="help-overlay-card" [ngStyle]="cardStyle">
      <p class="help-overlay-card__eyebrow">Step {{ state.index + 1 }} of {{ state.steps.length }}</p>
      <h2 class="help-overlay-card__title">{{ currentStep.title }}</h2>
      <p class="help-overlay-card__body">{{ currentStep.body }}</p>

      <div class="help-overlay-card__dots" role="tablist" aria-label="Help guide progress">
        <span
          *ngFor="let _ of state.steps; let i = index; trackBy: trackByIndex"
          class="help-overlay-card__dot"
          [class.help-overlay-card__dot--active]="i === state.index"></span>
      </div>

      <div class="help-overlay-card__actions">
        <button type="button" class="_cancel-btn" (click)="exit()">Exit</button>
        <div class="help-overlay-card__actions-spacer"></div>
        <button type="button" class="_outline-btn" (click)="back()" [disabled]="!canGoBack">Back</button>
        <button type="button" class="_primary-btn" *ngIf="!isLast" (click)="next()">Next</button>
        <button type="button" class="_primary-btn" *ngIf="isLast" (click)="finish()">Finish</button>
      </div>
    </div>
  </div>
</ng-container>
